import { combineLatest, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TaskModalMainHeaderItem } from './task-modal-main/task-modal-main.component';
import { TaskInfoDetailItem } from './task-info/task-info.component';
import { MachineInfo, PlantInfo } from '@schenck/rotec-components';
import { MachineTaskInfo } from 'src/api';
import { TypeEnumPipe } from '../type-enum.pipe';
import { TaskFunctionGroupPipe } from '../components-and-function-group';
import { map } from 'rxjs/operators';

export function getMachineTaskModalInfos(
  task$: Observable<MachineTaskInfo>,
  machine$: Observable<MachineInfo>,
  plant$: Observable<PlantInfo>,
  translate: TranslateService
) {
  return {
    task: task$,
    machinePictureId: machine$.pipe(map((machine) => machine.pictureId)),
    taskInfos: combineLatest([machine$, plant$]).pipe(
      map(([machine, plant]) => {
        return <TaskModalMainHeaderItem[][]>[
          [
            { name: 'Machine', value: machine.name },
            { name: 'Serial Number', value: machine.serial },
            { name: 'Plant', value: plant && plant.name },
          ],
        ];
      })
    ),
    details: task$.pipe(
      map(
        (task) =>
          <TaskInfoDetailItem[][]>[
            [
              { name: 'Task Responsible', value: task.responsible || '-' },
              { name: 'Task Type', value: TypeEnumPipe.translate(task.type, translate) },
              {
                name: 'Function Group',
                value: TaskFunctionGroupPipe.translate(task.functionGroup, translate) || '-',
              },
            ],
            [
              { name: 'Required Tooling', value: task.requiredTooling || '-' },
              { name: 'Possible Spare Parts', value: task.possibleSpareParts || '-' },
              {
                name: 'Expected Duration',
                value: task.expectedDurationMinutes
                  ? translate.instant('VALUE Minutes', {
                      value: task.expectedDurationMinutes,
                    })
                  : '-',
              },
            ],
          ]
      )
    ),
  };
}
